import { forwardRef } from 'react'

import { Checkbox } from '../Checkbox/index.js'
import { FormControlMeta } from './FormControlMeta.js'
import { FormControlCheckboxProps } from './types.js'

export const FormControlCheckbox = forwardRef<
  HTMLInputElement,
  FormControlCheckboxProps
>((props, ref) => {
  const { name, label, helperText, error, invalid, hidden, ...rest } = props

  return (
    <div hidden={hidden}>
      <Checkbox {...rest} name={name} invalid={invalid} ref={ref}>
        {label}
      </Checkbox>
      <FormControlMeta {...{ helperText, error, invalid }} />
    </div>
  )
})
